import { render, staticRenderFns } from "./ContextMenuResource.vue?vue&type=template&id=06d3a311&scoped=true"
import script from "./ContextMenuResource.vue?vue&type=script&lang=js"
export * from "./ContextMenuResource.vue?vue&type=script&lang=js"
import style0 from "./ContextMenuResource.vue?vue&type=style&index=0&id=06d3a311&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3a311",
  null
  
)

export default component.exports